import { Base } from './_base.model';

export class ApprovalGroup extends Base {
  id: number;
  request_form_id: number;
  client_levels: any[];
  rank: number;
}
